export default `
  subscription OnToggleCardReaction($workflowId: String) {
    onToggleCardReaction(workflowId: $workflowId) {
      workflowId
      cardId
      direction
      createdAt
      user {
        id
        firstname
        lastname
      }
    }
  }
`
